$( document ).ready(function() {

    $(document).delegate('.btn--dropdown', 'click', function () {
        var $block = $(this).parents('.block-dropdown');
        if ($block.hasClass('open')) {
            $block.removeClass('open');
        } else {
            $('.block-dropdown').removeClass('open');
            $block.addClass('open');
        }
        return false;
    });

    $(".video-download-one").click(function (event) {
        $('.video-download-one').removeClass('is-active');
        $(this).addClass('is-active');
    });

    //mobile tabs on Videopage
    (function() {
        var $tabs = $('.video-tabs-mobile');
        if (!$tabs.length) return false;
        var $page = $('.video-page');
        var show = function() {
            var tab = $tabs.find('li.active').children('a').attr('data-tab');
            $page.attr('data-tab-show', tab);
        };
        show();
        $tabs.find('a').on('click', function() {
            $(this).parent('li').addClass('active').siblings('li').removeClass('active');
            show();
            return false;
        });
    })();



    $(".video-options-wrap input:checkbox").on('click', function () {
        // in the handler, 'this' refers to the box clicked on
        var $box = $(this);
        if ($box.is(":checked")) {
            // the name of the box is retrieved using the .attr() method
            // as it is assumed and expected to be immutable
            var group = "input:checkbox[name='" + $box.attr("name") + "']";
            // the checked state of the group/box on the other hand will change
            // and the current value is retrieved using .prop() method
            $(group).prop("checked", false);
            $box.prop("checked", true);
        } else {
            $box.prop("checked", false);
        }
    });

    $(".video-options-wrap input").on('click', function () {
        $('.video-options-wrap .block-dropdown').removeClass('open');
    });

    $('input[id="pc-pltf"]').click(function () {
        if (($(this)).is(":checked")) {
            $('.video-download').addClass('is-active');
            $('.video-download:not(.pc-pltf)').removeClass('is-active');
            $('.pc-pltf .video-download-one').addClass('is-active');
            $('input[id="kdc-265"]').prop('disabled', false);
            $('input[id="kdc-vp8"]').prop('disabled', false);
        } else {
            $('.video-download').addClass('is-active');
            $('.pc-pltf .video-download-one').removeClass('is-active');
        }
    });

    $('input[id="mob-pltf"]').click(function () {
        if (($(this)).is(":checked")) {
            $('.video-download').addClass('is-active');
            $('.video-download:not(.mob-pltf)').removeClass('is-active');
            $('.mob-pltf .video-download-one').addClass('is-active');
            $('input[id="kdc-265"]').prop('disabled', false);
            $('input[id="kdc-vp8"]').prop('disabled', false);
        } else {
            $('.video-download').addClass('is-active');
            $('.mob-pltf .video-download-one').removeClass('is-active');

        }
    });

    $('input[id="ps-pltf"]').click(function () {
        if (($(this)).is(":checked")) {
            $('.video-download').addClass('is-active');
            $('.video-download:not(.ps-pltf)').removeClass('is-active');
            $('.ps-pltf .video-download-one').addClass('is-active');
            $('input[id="kdc-265"]').prop('disabled', true);
            $('input[id="kdc-vp8"]').prop('disabled', true);
        } else {
            $('.video-download').addClass('is-active');
            $('.ps-pltf .video-download-one').removeClass('is-active');
            $('input[id="kdc-265"]').prop('disabled', false);
            $('input[id="kdc-vp8"]').prop('disabled', false);
        }
    });

    $('input[id="kdc-264"]').click(function () {
        if (($(this)).is(":checked")) {
            $('.kodec-one').addClass('is-active ');
            $('.kodec-one:not(.kdc-264)').removeClass('is-active');
            $('input[id="ps-pltf"]').prop('disabled', false);

        } else {
            $('.kodec-one').addClass('is-active');
        }
    });

    $('input[id="kdc-265"]').click(function () {
        if (($(this)).is(":checked")) {
            $('.kodec-one').addClass('is-active');
            $('.kodec-one:not(.kdc-265)').removeClass('is-active');
            $('input[id="ps-pltf"]').prop('disabled', false);
            $('input[id="ps-pltf"]').prop('disabled', true);

        } else {
            $('.kodec-one').addClass('is-active');
            $('input[id="ps-pltf"]').prop('disabled', false);
        }
    });

    $('input[id="kdc-vp8"]').click(function () {
        if (($(this)).is(":checked")) {
            $('.kodec-one').addClass('is-active');
            $('.kodec-one:not(.kdc-vp8)').removeClass('is-active');
            $('input[id="ps-pltf"]').prop('disabled', true);

        } else {
            $('.kodec-one').addClass('is-active');
            $('input[id="ps-pltf"]').prop('disabled', false);
        }
    });
});